<!-- Описание заказ-наряда ремонта. -->
<template>
  <BaseFormSection title="Описание" icon="comment">
    <BaseFormField
      label="Описание"
      for-id="repair_title"
      :filled="isFieldFilled('title')"
      wide
    >
      <base-input
        id="repair_title"
        :model-value="formData.title"
        placeholder="Например: ТО, замена масла"
        @update:model-value="$emit('update-field', 'title', $event)"
      />
    </BaseFormField>

    <BaseFormField
      label="Подробное описание"
      for-id="repair_description"
      :filled="isFieldFilled('description')"
      wide
    >
      <base-textarea
        id="repair_description"
        :model-value="formData.description"
        placeholder="Причина обращения, где делали, важные детали"
        @update:model-value="$emit('update-field', 'description', $event)"
      />
    </BaseFormField>
  </BaseFormSection>
</template>

<script>
export default {
  name: "FleetRepairDescriptionSection",

  props: {
    formData: { type: Object, required: true },
  },

  emits: ["update-field"],

  methods: {
    isFieldFilled(field) {
      return Boolean(this.formData[field]);
    },
  },
};
</script>
